import React, { Component } from 'react';
import ContentsThumbnail from './ContentsThumbnail';
import ContentsPreview from './ContentsPreview';

class ContentsAllItem extends Component {

    render() {
        const { no, board } = this.props;
        const { siteNum, title, contentKindCode, boardID, attachedFiles, thumbnailFiles } = board;
        let boardFileID = 0;
        if (contentKindCode === "CK002" && attachedFiles.length > 0) boardFileID = attachedFiles[(attachedFiles.length - 1)].boardFileID;
        if (contentKindCode === "CK003" && thumbnailFiles.length > 0) boardFileID = thumbnailFiles[(thumbnailFiles.length - 1)].boardFileID;

        return (
            <tr className="contents-all-item">
                <td className="text-align-center">{no}</td>
                <td className="text-align-center">{siteNum}</td>
                <td className="text-align-center">{contentKindCode === "CK001" ? "공지" : (contentKindCode === "CK002" ? "이미지광고" : "영상광고")}</td>
                <td className="text-align-center"><ContentsThumbnail contentKindCode={contentKindCode} boardID={boardID} boardFileID={boardFileID} /> </td>
                <td className="text-align-left contents-all-item-title padding-l10">{title}</td>
                <td className="text-align-center"><ContentsPreview board={board} /></td>
            </tr>
        )
    }
}

export default (ContentsAllItem);